import { Product } from '../utils/types'

export const products: Product[] = [
  // --- DOG FOOD ---
  {
    id: 'dog-vitalpaws-balance',
    name: 'VitalPaws Balance Adult',
    description:
      'Nutrición integral diseñada para perros adultos con nivel de actividad medio-alto. Nuestra fórmula exclusiva combina un 40% de pollo de corral fresco con superalimentos seleccionados para garantizar una energía sostenida durante todo el día. Los prebióticos naturales favorecen una digestión ligera, mientras que el equilibrio óptimo de Omega-3 y 6 asegura un pelaje brillante y una piel sana en solo 3 semanas.',
    price: 45.99,
    originalPrice: 49.99,
    image:
      'https://images.unsplash.com/photo-1568640347023-a616a30bc3bd?w=600&h=600&fit=crop',
    category: 'dog-food',
    subcategory: 'adult',
    petType: 'dog',
    ageGroup: 'adult',
    benefits: [
      'Sistema inmune reforzado',
      'Pelaje visiblemente más brillante',
      'Digestión ligera y regular',
      'Energía estable todo el día',
    ],
    ingredients: [
      'Pollo de corral fresco (40%)',
      'Arroz integral selecto',
      'Zanahoria deshidratada',
      'Espinacas ricas en hierro',
      'Aceite de salmón noruego',
    ],
    ingredientDetails: [
      {
        name: 'Pollo de corral',
        percentage: '40%',
        purpose: 'Fuente principal de proteína de alta biodisponibilidad',
        benefits: [
          'Mantenimiento de masa muscular magra',
          'Alta digestibilidad',
        ],
      },
      {
        name: 'Arroz integral',
        percentage: '25%',
        purpose: 'Carbohidrato complejo de liberación lenta',
        benefits: [
          'Energía sostenida sin picos de glucosa',
          'Fibra prebiótica',
        ],
      },
      {
        name: 'Aceite de salmón',
        percentage: '2%',
        purpose: 'Fuente pura de ácidos grasos Omega-3',
        benefits: ['Reducción de inflamación', 'Salud dermatológica superior'],
      },
    ],
    sustainability:
      'Envase 100% reciclable. Producción con energía solar certificada. Huella de carbono compensada.',
    weight: '12kg',
    inStock: true,
    stock: 50,
    featured: true,
    rating: 4.9,
    reviewCount: 128,
    certifications: [
      'FEDIAF Compliant',
      'Km 0',
      'Human Grade Ingredients',
      'Carbon Neutral',
    ],
    manufacturingInfo: {
      madeIn: 'España',
      batchTracking: true,
      shelfLife: '18 meses',
      storageInstructions:
        'Conservar en lugar fresco, seco y alejado de la luz solar directa',
    },
    nutritionalInfo: {
      crudeProtein: '28%',
      crudeFat: '16%',
      crudeFiber: '3.5%',
      crudeAsh: '7.5%',
      moisture: '10%',
      omega3: '0.8%',
      omega6: '2.4%',
      kcalPer100g: 385,
      calcium: '1.2%',
      phosphorus: '1.0%',
      glucosamine: '500 mg/kg',
    },
  },
  {
    id: 'dog-puppygrow-formula',
    name: 'PuppyGrow Start Formula',
    description:
      'El comienzo perfecto para tu cachorro. Una receta científicamente formulada para apoyar el rápido crecimiento durante los primeros 12 meses. Enriquecida con niveles óptimos de DHA (como en la leche materna) para potenciar el desarrollo cognitivo y visual, y calcio equilibrado para formar huesos fuertes y articulaciones sanas.',
    price: 42.99,
    image:
      'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&h=600&fit=crop',
    category: 'dog-food',
    subcategory: 'puppy',
    petType: 'dog',
    ageGroup: 'puppy',
    benefits: [
      'Desarrollo cerebral (DHA)',
      'Huesos y dientes fuertes',
      'Crecimiento muscular armonioso',
      'Refuerzo de defensas naturales',
    ],
    ingredients: [
      'Pavo fresco deshuesado (45%)',
      'Batata dulce',
      'Guisantes tiernos',
      'Aceite de pescado rico en DHA',
      'Carbonato de calcio',
    ],
    ingredientDetails: [
      {
        name: 'Pavo fresco',
        percentage: '45%',
        purpose: 'Proteína magra esencial para el crecimiento',
        benefits: [
          'Desarrollo de tejido nuevo',
          'Fácil digestión para estómagos jóvenes',
        ],
      },
      {
        name: 'Aceite de pescado',
        percentage: '3%',
        purpose: 'Fuente crítica de DHA y EPA',
        benefits: ['Mejora el aprendizaje', 'Desarrollo de la retina'],
      },
    ],
    sustainability: 'Ingredientes de granjas locales certificadas.',
    weight: '8kg',
    inStock: true,
    stock: 4, // Low stock for testing indicator
    rating: 4.8,
    reviewCount: 82,
    certifications: ['FEDIAF Compliant', 'Grain Free', 'Vet Recommended'],
    nutritionalInfo: {
      crudeProtein: '32%',
      crudeFat: '18%',
      crudeFiber: '3%',
      crudeAsh: '8%',
      moisture: '10%',
      calcium: '1.4%',
      phosphorus: '1.1%',
      kcalPer100g: 410,
      omega3: '1.2%',
    },
  },
  {
    id: 'dog-seniorguard-crunch',
    name: 'SeniorGuard Vitality',
    description:
      'Redescubre la vitalidad de tu perro senior (7+). Fórmula avanzada con condroprotectores naturales (glucosamina y condroitina) para mantener la movilidad articular. Croquetas diseñadas para facilitar la masticación y un perfil calórico ajustado para prevenir el sobrepeso, común en edades avanzadas.',
    price: 48.99,
    image:
      'https://images.unsplash.com/photo-1535930749574-1399327ce78f?w=600&h=600&fit=crop',
    category: 'dog-food',
    subcategory: 'senior',
    petType: 'dog',
    ageGroup: 'senior',
    benefits: [
      'Protección articular activa',
      'Control de peso efectivo',
      'Salud cardíaca (Taurina)',
      'Fácil masticación y digestión',
    ],
    ingredients: [
      'Cordero de pasto (35%)',
      'Avena integral',
      'Sulfato de Glucosamina',
      'Condroitina',
      'Arándanos antioxidantes',
    ],
    sustainability: 'Packaging 100% biodegradable y compostable.',
    weight: '10kg',
    inStock: true,
    stock: 30,
    rating: 4.7,
    reviewCount: 56,
    certifications: ['Joint Support Complex', 'Low Calorie', 'Heart Health'],
    nutritionalInfo: {
      crudeProtein: '24%',
      crudeFat: '12%',
      crudeFiber: '5%',
      crudeAsh: '7%',
      moisture: '10%',
      glucosamine: '1200 mg/kg',
      chondroitin: '900 mg/kg',
      kcalPer100g: 345,
    },
  },
  {
    id: 'dog-purenature-grainfree',
    name: 'PureNature Salmon Grain-Free',
    description:
      'La solución definitiva para sensibilidades digestivas. Receta hipoalergénica monoproteica con un 50% de salmón salvaje. Totalmente libre de cereales, gluten y soja. Rica en ácidos grasos esenciales que calman la piel irritada y fortalecen la barrera cutánea.',
    price: 54.99,
    image:
      'https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=600&h=600&fit=crop',
    category: 'dog-food',
    subcategory: 'special-diet',
    petType: 'dog',
    ageGroup: 'adult',
    benefits: [
      'Hipoalergénico certificado',
      'Cero cereales (Grain-Free)',
      'Alivio de picores cutáneos',
      'Digestión ultra-suave',
    ],
    ingredients: [
      'Salmón salvaje fresco (50%)',
      'Patata',
      'Calabaza digestiva',
      'Algas marinas (fuente de yodo)',
      'Prebióticos FOS/MOS',
    ],
    sustainability: 'Pesca sostenible certificada MSC.',
    weight: '10kg',
    inStock: true,
    stock: 25,
    featured: true,
    rating: 4.9,
    reviewCount: 94,
    certifications: ['MSC Certified', 'Grain Free', 'Hypoallergenic'],
    nutritionalInfo: {
      crudeProtein: '26%',
      crudeFat: '15%',
      crudeFiber: '3.5%',
      crudeAsh: '8%',
      moisture: '10%',
      omega3: '1.5%',
      omega6: '2.0%',
      kcalPer100g: 375,
    },
  },
  {
    id: 'dog-barf-bites-fresh',
    name: 'BARF-Bites Dehydrated Raw',
    description:
      'Toda la potencia nutricional de la dieta cruda (BARF) con la comodidad del alimento seco. Carne de ternera de alta calidad deshidratada suavemente a baja temperatura para conservar enzimas y nutrientes vitales. Solo añade agua tibia para servir una comida fresca y natural.',
    price: 59.99,
    image:
      'https://images.unsplash.com/photo-1589924691995-400dc9ecc119?w=600&h=600&fit=crop',
    category: 'dog-food',
    subcategory: 'barf',
    petType: 'dog',
    ageGroup: 'all',
    benefits: [
      'Nutrición cruda segura',
      'Enzimas naturales intactas',
      'Sabor instintivo irresistible',
      'Hidratación óptima al preparar',
    ],
    ingredients: [
      'Ternera deshidratada (60%)',
      'Hígado de ternera',
      'Manzana fresca',
      'Zanahoria',
      'Hueso carnoso molido',
    ],
    sustainability: 'Ganado de pasto extensivo.',
    weight: '5kg',
    inStock: true,
    stock: 15,
    rating: 5.0,
    reviewCount: 42,
    certifications: ['Raw Food Safe', 'Human Grade', 'No Synthetics'],
    nutritionalInfo: {
      crudeProtein: '45%',
      crudeFat: '25%',
      crudeFiber: '2%',
      crudeAsh: '6%',
      moisture: '8%',
      kcalPer100g: 480,
    },
  },
  // NEW DOG PRODUCTS
  {
    id: 'dog-weight-control',
    name: 'HealthyWeight Light Control',
    description:
      'Ayuda a tu perro a recuperar su peso ideal sin pasar hambre. Fórmula saciante rica en fibra y baja en grasas, enriquecida con L-carnitina para potenciar la quema de reservas grasas mientras se mantiene la masa muscular magra.',
    price: 46.99,
    image:
      'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=600&h=600&fit=crop',
    category: 'dog-food',
    subcategory: 'special-diet',
    petType: 'dog',
    ageGroup: 'adult',
    benefits: [
      'Pérdida de peso saludable',
      'Efecto saciante natural',
      'Quema de grasas (L-carnitina)',
      'Mantenimiento muscular',
    ],
    ingredients: [
      'Pavo magro (35%)',
      'Lentejas (fibra)',
      'Fibra de guisante',
      'L-carnitina',
      'Espinacas frescas',
    ],
    sustainability: 'Producción local de bajo impacto.',
    weight: '12kg',
    inStock: true,
    stock: 40,
    rating: 4.6,
    reviewCount: 35,
    certifications: ['Weight Control', 'Low Fat', 'High Fiber'],
    nutritionalInfo: {
      crudeProtein: '30%',
      crudeFat: '9%',
      crudeFiber: '8%',
      crudeAsh: '7%',
      moisture: '10%',
      kcalPer100g: 310,
    },
  },
  {
    id: 'dog-sensitive-stomach',
    name: 'DigestiveCare Pro Rabbit',
    description:
      'Alivio inmediato para estómagos delicados. Proteína novel de conejo (única fuente animal) altamente digestible. Fórmula enriquecida con un complejo exclusivo de probióticos y prebióticos para restaurar y equilibrar la flora intestinal dañada.',
    price: 58.99,
    image:
      'https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?w=600&h=600&fit=crop',
    category: 'dog-food',
    subcategory: 'special-diet',
    petType: 'dog',
    ageGroup: 'adult',
    benefits: [
      'Digestión sin molestias',
      'Restauración flora intestinal',
      'Heces firmes y regulares',
      'Proteína novel (Conejo)',
    ],
    ingredients: [
      'Conejo fresco (45%)',
      'Patata dulce',
      'Calabaza',
      'Inulina (Prebiótico)',
      'Bacillus subtilis (Probiótico)',
    ],
    sustainability: 'Conejo de granja ética certificada.',
    weight: '10kg',
    inStock: true,
    stock: 20,
    rating: 4.9,
    reviewCount: 67,
    certifications: ['Monoprotein', 'Probiotics Enhanced', 'Sensitive Stomach'],
    nutritionalInfo: {
      crudeProtein: '26%',
      crudeFat: '14%',
      crudeFiber: '3%',
      crudeAsh: '7.5%',
      moisture: '10%',
      kcalPer100g: 365,
    },
  },
  {
    id: 'dog-active-performance',
    name: 'ActivePro Performance High Energy',
    description:
      'Combustible premium para atletas caninos. Diseñado para perros de trabajo, deporte o muy activos. Aporta una densidad calórica superior y proteínas de rápida absorción para maximizar la resistencia y acelerar la recuperación muscular tras el ejercicio intenso.',
    price: 52.99,
    image:
      'https://images.unsplash.com/photo-1552053831-71594a27632d?w=600&h=600&fit=crop',
    category: 'dog-food',
    subcategory: 'adult',
    petType: 'dog',
    ageGroup: 'adult',
    benefits: [
      'Energía explosiva y duradera',
      'Recuperación muscular rápida',
      'Resistencia a la fatiga',
      'Articulaciones protegidas',
    ],
    ingredients: [
      'Pato fresco (30%)',
      'Salmón (20%)',
      'Grasa de pato purificada',
      'Boniato (energía)',
      'Huevo entero deshidratado',
    ],
    sustainability: 'Fábrica con energía 100% renovable.',
    weight: '12kg',
    inStock: true,
    stock: 35,
    rating: 4.8,
    reviewCount: 45,
    certifications: ['High Energy', 'Sport Performance', 'Muscle Recovery'],
    nutritionalInfo: {
      crudeProtein: '34%',
      crudeFat: '22%',
      crudeFiber: '2.5%',
      crudeAsh: '8%',
      moisture: '10%',
      kcalPer100g: 440,
    },
  },

  // --- CAT FOOD ---
  {
    id: 'cat-felinefresco-delight',
    name: 'FelineFresco Gourmet Tuna',
    description:
      'Una experiencia culinaria irresistible para tu gato. Filetes de atún real y gambas en su propio caldo. Proporciona la hidratación vital que los gatos necesitan para prevenir problemas urinarios, con un sabor que satisface incluso a los paladares más exigentes.',
    price: 39.99,
    originalPrice: 44.99,
    image:
      'https://images.unsplash.com/photo-1574158622682-e40e69881006?w=600&h=600&fit=crop',
    category: 'cat-food',
    subcategory: 'wet',
    petType: 'cat',
    ageGroup: 'adult',
    benefits: [
      'Hidratación renal óptima',
      'Salud cardíaca (Taurina natural)',
      'Alta palatabilidad garantizada',
      'Textura natural en filetes',
    ],
    ingredients: [
      'Atún listado (50%)',
      'Caldo de pescado natural',
      'Gambas enteras',
      'Taurina añadida',
      'Vitaminas esenciales',
    ],
    sustainability: 'Pesca responsable Dolphin Safe.',
    weight: 'Pack 24x85g',
    inStock: true,
    stock: 60,
    featured: true,
    rating: 4.8,
    reviewCount: 156,
    certifications: ['Dolphin Safe', 'Grain Free', 'No Artificial Flavors'],
    nutritionalInfo: {
      crudeProtein: '14%',
      crudeFat: '2%',
      crudeFiber: '0.5%',
      crudeAsh: '2%',
      moisture: '82%',
      taurine: '1500 mg/kg',
      kcalPer100g: 85,
    },
  },
  {
    id: 'cat-indoorwhiskers-blend',
    name: 'IndoorWhiskers Control',
    description:
      'Formulado específicamente para el estilo de vida sedentario del gato de interior. Ayuda a prevenir el sobrepeso con calorías controladas y reduce significativamente la formación de bolas de pelo gracias a fibras vegetales especializadas. Incluye extracto de yuca para minimizar el olor de la bandeja sanitaria.',
    price: 34.99,
    image:
      'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=600&h=600&fit=crop',
    category: 'cat-food',
    subcategory: 'indoor',
    petType: 'cat',
    ageGroup: 'adult',
    benefits: [
      'Control de peso efectivo',
      'Reducción de bolas de pelo',
      'Heces con menos olor',
      'Salud del tracto urinario',
    ],
    ingredients: [
      'Pavo fresco (40%)',
      'Fibra vegetal (celulosa)',
      'Yuca Schidigera',
      'L-carnitina',
      'Arándanos rojos',
    ],
    sustainability: 'Saco de papel reciclado.',
    weight: '4kg',
    inStock: true,
    stock: 40,
    rating: 4.7,
    reviewCount: 89,
    certifications: ['Indoor Formula', 'Odor Control', 'Hairball Control'],
    nutritionalInfo: {
      crudeProtein: '32%',
      crudeFat: '12%',
      crudeFiber: '6%',
      crudeAsh: '7%',
      moisture: '10%',
      kcalPer100g: 350,
    },
  },
  {
    id: 'cat-sterilized-care',
    name: 'SterilizedCare Salmon Balance',
    description:
      'Cuidado experto para gatos esterilizados. Equilibrio mineral preciso para mantener el pH urinario óptimo y prevenir cristales. Aporte calórico reducido para contrarrestar la tendencia al aumento de peso tras la esterilización, sin sacrificar el sabor del salmón fresco.',
    price: 36.99,
    image:
      'https://images.unsplash.com/photo-1513245543132-31f507417b26?w=600&h=600&fit=crop',
    category: 'cat-food',
    subcategory: 'adult',
    petType: 'cat',
    ageGroup: 'adult',
    benefits: [
      'Salud urinaria (pH Control)',
      'Prevención de obesidad',
      'Saciedad entre comidas',
      'Pelaje suave y brillante',
    ],
    ingredients: [
      'Salmón fresco (35%)',
      'Pollo deshidratado',
      'Guisantes',
      'Aceite de pescado',
      'Arándanos rojos (salud urinaria)',
    ],
    sustainability: 'Pesca sostenible certificada.',
    weight: '4kg',
    inStock: true,
    stock: 55,
    rating: 4.8,
    reviewCount: 112,
    certifications: ['Sterilized Formula', 'pH Control', 'Urinary Health'],
    nutritionalInfo: {
      crudeProtein: '36%',
      crudeFat: '11%',
      crudeFiber: '4%',
      crudeAsh: '7.5%',
      moisture: '10%',
      kcalPer100g: 360,
    },
  },
  {
    id: 'cat-kitten-start',
    name: 'KittenStart Brain & Body',
    description:
      'Nutrición fundamental para el primer año de vida. Croquetas adaptadas a bocas pequeñas, cargadas de proteínas para el crecimiento y DHA natural para un desarrollo cerebral superior. Fortalece el sistema inmune inmaduro con antioxidantes y vitaminas.',
    price: 28.99,
    image:
      'https://images.unsplash.com/photo-1592194996308-7b43878e84a6?w=600&h=600&fit=crop',
    category: 'cat-food',
    subcategory: 'adult', // Should be kitten but using existing types
    petType: 'cat',
    ageGroup: 'kitten',
    benefits: [
      'Crecimiento óptimo y seguro',
      'Desarrollo cognitivo (DHA)',
      'Defensas naturales fuertes',
      'Digestión ultra-fácil',
    ],
    ingredients: [
      'Pollo fresco (50%)',
      'Huevo entero deshidratado',
      'Aceite de salmón',
      'Prebióticos FOS',
      'Taurina esencial',
    ],
    sustainability: 'Pollo de corral certificado.',
    weight: '2kg',
    inStock: true,
    stock: 30,
    rating: 4.9,
    reviewCount: 45,
    certifications: ['Kitten Formula', 'DHA Rich', 'Immune Support'],
    nutritionalInfo: {
      crudeProtein: '40%',
      crudeFat: '20%',
      crudeFiber: '2%',
      crudeAsh: '8%',
      moisture: '10%',
      kcalPer100g: 425,
    },
  },

  // --- SNACKS ---
  {
    id: 'snack-chewyjoy-strips',
    name: 'ChewyJoy Duck Strips',
    description:
      'El premio perfecto y saludable. Tiras de pechuga de pato real (95%) secadas al aire. Una textura masticable que satisface el instinto natural y ayuda a limpiar suavemente los dientes. Sin azúcares añadidos ni rellenos artificiales.',
    price: 12.99,
    image:
      'https://images.unsplash.com/photo-1582798358481-d199fb7347bb?w=600&h=600&fit=crop',
    category: 'snacks',
    subcategory: 'chews',
    petType: 'dog',
    ageGroup: 'all',
    benefits: [
      'Entretenimiento saludable',
      'Limpieza dental mecánica',
      'Proteína de alta calidad',
      'Bajo en grasa (Light)',
    ],
    ingredients: ['Pechuga de pato (95%)', 'Glicerina vegetal natural'],
    sustainability: 'Pato de origen sostenible.',
    weight: '200g',
    inStock: true,
    stock: 100,
    rating: 4.8,
    reviewCount: 210,
    certifications: ['High Protein', 'Natural Ingredients', 'No Sugar Added'],
  },
  {
    id: 'snack-lickotreat-freeze',
    name: 'LickoTreat Freeze-Dried Liver',
    description:
      'Puro sabor concentrado. Hígado de ternera 100% liofilizado para preservar todos los nutrientes y un aroma irresistible. Ideal como premio de alto valor para entrenamiento o para mascotas con alergias severas (un solo ingrediente).',
    price: 15.99,
    image:
      'https://images.unsplash.com/photo-1623366302587-b38b1ddaefd9?w=600&h=600&fit=crop',
    category: 'snacks',
    subcategory: 'freeze-dried',
    petType: 'both',
    ageGroup: 'all',
    benefits: [
      'Sabor intenso natural',
      'Hipoalergénico (1 ingrediente)',
      'Nutrientes intactos',
      'Perfecto para entrenamiento',
    ],
    ingredients: ['Hígado de ternera (100%)'],
    sustainability: 'Producción local ética.',
    weight: '100g',
    inStock: true,
    stock: 80,
    rating: 4.9,
    reviewCount: 115,
    certifications: [
      'Freeze Dried Technology',
      'Single Ingredient',
      'Grain Free',
    ],
  },
  {
    id: 'snack-purrcrunch-bites',
    name: 'PurrCrunch Creamy Centers',
    description:
      'Doble textura irresistible para gatos: crujiente por fuera, cremoso por dentro. Enriquecidos con taurina vital y bajos en calorías (menos de 2 kcal por pieza). El capricho diario perfecto sin culpa.',
    price: 8.99,
    image:
      'https://images.unsplash.com/photo-1513245543132-31f507417b26?w=600&h=600&fit=crop',
    category: 'snacks',
    subcategory: 'treats',
    petType: 'cat',
    ageGroup: 'all',
    benefits: [
      'Textura dual estimulante',
      'Alta palatabilidad',
      'Con Taurina esencial',
      'Bajo en calorías',
    ],
    ingredients: [
      'Pollo fresco',
      'Queso crema',
      'Harina de arroz',
      'Aceite de salmón',
    ],
    sustainability: 'Ingredientes éticos.',
    weight: '60g',
    inStock: true,
    stock: 120,
    rating: 4.7,
    reviewCount: 98,
    certifications: ['With Taurine', 'Low Calorie Treat'],
  },
  {
    id: 'snack-boneboost-rolls',
    name: 'BoneBoost Collagen Rolls',
    description:
      'Entretenimiento duradero con beneficios reales. Rollos masticables ricos en colágeno natural para apoyar la salud de articulaciones, piel y pelaje. Una alternativa segura y digerible al cuero crudo tradicional.',
    price: 18.99,
    image:
      'https://images.unsplash.com/photo-1548767797-d8c844163c4c?w=600&h=600&fit=crop',
    category: 'snacks',
    subcategory: 'chews',
    petType: 'dog',
    ageGroup: 'adult',
    benefits: [
      'Masticación de larga duración',
      'Aporte de colágeno natural',
      'Reducción de ansiedad',
      'Alternativa segura al cuero',
    ],
    ingredients: [
      'Capa interna de piel de vacuno',
      'Colágeno hidrolizado',
      'Carne de pollo',
    ],
    sustainability: 'Aprovechamiento integral sostenible.',
    weight: '3 unidades',
    inStock: true,
    stock: 60,
    rating: 4.6,
    reviewCount: 45,
    certifications: ['Rawhide Free Alternative', 'Collagen Rich'],
  },
  {
    id: 'snack-trainingtasty-minis',
    name: 'TrainingTasty Pro Minis',
    description:
      'Diseñados por adiestradores. Pequeños bocados blandos de rápida ingestión para no interrumpir el flujo de entrenamiento. Aroma potente para mantener la atención y bajo contenido calórico para sesiones largas.',
    price: 9.99,
    image:
      'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=600&h=600&fit=crop',
    category: 'snacks',
    subcategory: 'training',
    petType: 'dog',
    ageGroup: 'all',
    benefits: [
      'Tamaño perfecto para premios',
      'Bajo en calorías (<3kcal)',
      'Aroma motivador intenso',
      'No mancha los bolsillos',
    ],
    ingredients: ['Pavo', 'Patata', 'Romero', 'Glicerina vegetal'],
    sustainability: 'Producción local.',
    weight: '150g',
    inStock: true,
    stock: 150,
    rating: 4.8,
    reviewCount: 230,
    certifications: ['Trainer Approved', 'Low Calorie'],
  },
  {
    id: 'snack-vitalsnack-liver',
    name: 'VitalSnack Pork Liver',
    description:
      'Superalimento natural. Hígado de cerdo deshidratado, una de las fuentes más ricas en hierro, vitamina A y vitaminas B. Un suplemento nutricional disfrazado de premio delicioso.',
    price: 13.99,
    image:
      'https://images.unsplash.com/photo-1589924691995-400dc9ecc119?w=600&h=600&fit=crop',
    category: 'snacks',
    subcategory: 'natural',
    petType: 'dog',
    ageGroup: 'all',
    benefits: [
      'Energía y vitalidad extra',
      'Salud ocular (Vit A)',
      'Refuerzo sanguíneo (Hierro)',
      'Sin aditivos ni conservantes',
    ],
    ingredients: ['Hígado de cerdo (100%)'],
    sustainability: 'Aprovechamiento integral.',
    weight: '150g',
    inStock: true,
    stock: 70,
    rating: 4.7,
    reviewCount: 65,
    certifications: ['Natural Superfood', 'No Additives'],
  },
  {
    id: 'snack-calmbites-herbal',
    name: 'CalmBites Relaxing Chews',
    description:
      'Apoyo natural para momentos de estrés. Snacks funcionales formulados con manzanilla, valeriana y triptófano. Ideales para tormentas, viajes, visitas al veterinario o ansiedad por separación. Relajación sin sedación.',
    price: 16.99,
    image:
      'https://images.unsplash.com/photo-1608408843596-b311965e04cb?w=600&h=600&fit=crop',
    category: 'snacks',
    subcategory: 'functional',
    petType: 'both',
    ageGroup: 'all',
    benefits: [
      'Efecto calmante natural',
      'Reduce comportamientos nerviosos',
      'Sin efecto sedante/drogado',
      'Ideal para viajes',
    ],
    ingredients: [
      'Pollo',
      'Extracto de Manzanilla',
      'Raíz de Valeriana',
      'Pasiflora',
      'L-Triptófano',
    ],
    sustainability: 'Hierbas de cultivo ecológico.',
    weight: '120g',
    inStock: true,
    stock: 55,
    rating: 4.5,
    reviewCount: 88,
    certifications: ['Vet Formulated', 'Natural Calming'],
  },
  {
    id: 'snack-dental-sticks',
    name: 'DentalFresh Star Sticks',
    description:
      'Higiene oral diaria fácil y efectiva. Su diseño en forma de estrella llega a los espacios interdentales difíciles. Contiene ingredientes activos como algas y té verde que combaten las bacterias causantes de placa y mal aliento.',
    price: 11.99,
    image:
      'https://images.unsplash.com/photo-1599409636295-e3cf3538f212?w=600&h=600&fit=crop',
    category: 'snacks',
    subcategory: 'chews',
    petType: 'dog',
    ageGroup: 'all',
    benefits: [
      'Aliento fresco duradero',
      'Reducción de placa bacteriana',
      'Encías más sanas',
      'Bajo en calorías',
    ],
    ingredients: [
      'Almidón de patata',
      'Glicerina',
      'Algas marinas (Ascophyllum)',
      'Extracto de Té verde',
      'Aceite de Eucalipto',
    ],
    sustainability: '100% Vegetal.',
    weight: '28 unidades',
    inStock: true,
    stock: 120,
    rating: 4.7,
    reviewCount: 95,
    certifications: ['Dental Care', 'Plant Based'],
  },
  {
    id: 'snack-cat-creamy',
    name: 'CreamyLick Salmon Tubes',
    description:
      'El momento favorito de tu gato. Puré cremoso de salmón en tubos individuales. Perfecto para dar de la mano y fortalecer el vínculo, o como topper para hacer irresistible la comida seca. Alta humedad para la salud renal.',
    price: 7.99,
    image:
      'https://images.unsplash.com/photo-1574158622682-e40e69881006?w=600&h=600&fit=crop',
    category: 'snacks',
    subcategory: 'treats',
    petType: 'cat',
    ageGroup: 'all',
    benefits: [
      'Hidratación suplementaria',
      'Vínculo afectivo dueño-gato',
      'Sin cereales ni conservantes',
      'Irresistible para inapetentes',
    ],
    ingredients: [
      'Salmón (40%)',
      'Caldo de pollo',
      'Almidón de tapioca',
      'Aceite vegetal',
    ],
    sustainability: 'Pesca MSC.',
    weight: '4x15g',
    inStock: true,
    stock: 200,
    rating: 4.9,
    reviewCount: 180,
    certifications: ['Grain Free', 'High Moisture'],
  },

  // --- CARE ---
  {
    id: 'care-dentalbite-chews',
    name: 'DentalBite Enzymatic Chews',
    description:
      'Limpieza dental profunda con acción enzimática. Masticables diseñados para trabajar con la saliva de tu perro, liberando enzimas que descomponen el sarro. La textura abrasiva limpia físicamente la superficie del diente.',
    price: 14.99,
    image:
      'https://images.unsplash.com/photo-1599409636295-e3cf3538f212?w=600&h=600&fit=crop',
    category: 'care',
    subcategory: 'dental',
    petType: 'dog',
    ageGroup: 'adult',
    benefits: [
      'Reducción visible de sarro',
      'Combate el mal aliento de raíz',
      'Acción enzimática natural',
      'Limpieza profunda',
    ],
    ingredients: [
      'Almidón de patata',
      'Glicerina',
      'Menta',
      'Eucalipto',
      'Hexametafosfato de sodio',
    ],
    sustainability: 'Ingredientes vegetales.',
    weight: 'Pack 7 unidades',
    inStock: true,
    stock: 90,
    rating: 4.8,
    reviewCount: 142,
    certifications: ['Vet Recommended', 'Enzymatic Action'],
  },
  {
    id: 'care-toothguard-paste',
    name: 'ToothGuard Enzymatic Paste',
    description:
      'Cepillado fácil y efectivo. Pasta dental enzimática con sabor a pollo que a las mascotas les encanta. No requiere enjuague y puede usarse con o sin cepillo (aplicando en encías) para combatir la placa.',
    price: 11.99,
    image:
      'https://images.unsplash.com/photo-1551106652-a5bcf4b29ab6?w=600&h=600&fit=crop',
    category: 'care',
    subcategory: 'dental',
    petType: 'both',
    ageGroup: 'all',
    benefits: [
      'Acción enzimática potente',
      'Sabor aceptado (Pollo)',
      'Previene gingivitis',
      'Sin necesidad de enjuague',
    ],
    ingredients: [
      'Sorbitol',
      'Sílice hidratada',
      'Complejo enzimático',
      'Saborizante natural',
    ],
    sustainability: 'Tubo reciclable.',
    weight: '100g',
    inStock: true,
    stock: 65,
    rating: 4.4,
    reviewCount: 38,
    certifications: ['Vet Formulated', 'Safe to Swallow'],
  },
  {
    id: 'care-watersmile-additive',
    name: 'WaterSmile Oral Solution',
    description:
      'Higiene oral sin esfuerzo. Simplemente añade un tapón al bebedero diario. Su fórmula con clorofila y té verde combate las bacterias del mal aliento y previene la formación de placa, sin alterar el sabor del agua.',
    price: 19.99,
    image:
      'https://images.unsplash.com/photo-1548802673-380ab8ebc7b7?w=600&h=600&fit=crop',
    category: 'care',
    subcategory: 'dental',
    petType: 'both',
    ageGroup: 'all',
    benefits: [
      'Aliento fresco 24h',
      'Cero esfuerzo (añadir al agua)',
      'Insípido e inodoro',
      'Mantenimiento de encías',
    ],
    ingredients: [
      'Agua purificada',
      'Clorofilina',
      'Extracto de té verde',
      'Benzoato de sodio',
    ],
    sustainability: 'Botella plástico reciclado.',
    weight: '500ml',
    inStock: true,
    stock: 40,
    rating: 4.3,
    reviewCount: 52,
    certifications: ['Easy Care', 'Vet Approved'],
  },
  {
    id: 'care-bonebroth-toppers',
    name: 'BoneBroth Collagen Cubes',
    description:
      'Un boost de nutrición y sabor. Caldo de huesos cocinado a fuego lento durante 24h y deshidratado en cubitos. Rico en colágeno natural, aminoácidos y minerales. Ideal para rehidratar pienso, apoyar articulaciones o recuperar convalecientes.',
    price: 24.99,
    image:
      'https://images.unsplash.com/photo-1604542031658-579824d1f579?w=600&h=600&fit=crop',
    category: 'care',
    subcategory: 'supplement',
    petType: 'both',
    ageGroup: 'all',
    benefits: [
      'Salud intestinal (Leaky Gut)',
      'Refuerzo articular (Colágeno)',
      'Hidratación deliciosa',
      'Estimulante del apetito',
    ],
    ingredients: [
      'Caldo de huesos concentrado',
      'Cúrcuma orgánica',
      'Pimienta negra',
    ],
    sustainability: 'Cocción energéticamente eficiente.',
    weight: 'Pack 30 cubitos',
    inStock: true,
    stock: 35,
    rating: 4.9,
    reviewCount: 76,
    certifications: ['Human Grade', 'Paleo Friendly'],
  },
  {
    id: 'care-yogurpaws-treats',
    name: 'YogurPaws Probiotic Drops',
    description:
      'Probióticos deliciosos. Gotas de yogur liofilizado con frutas reales. Una forma premiada de aportar millones de cultivos vivos beneficiosos para la salud digestiva e inmunológica de tu mascota. Sin lactosa.',
    price: 10.99,
    image:
      'https://images.unsplash.com/photo-1571212515416-f223d9eb6878?w=600&h=600&fit=crop',
    category: 'snacks',
    subcategory: 'functional',
    petType: 'both',
    ageGroup: 'all',
    benefits: [
      'Equilibrio flora intestinal',
      'Refuerzo sistema inmune',
      'Sin lactosa (digestible)',
      'Fuente de calcio natural',
    ],
    ingredients: [
      'Yogur sin lactosa',
      'Fresas liofilizadas',
      'Arándanos',
      'Miel',
    ],
    sustainability: 'Leche de pasto.',
    weight: '50g',
    inStock: true,
    stock: 85,
    rating: 4.8,
    reviewCount: 94,
    certifications: ['Probiotic Rich', 'Lactose Free'],
  },
  {
    id: 'care-joint-support',
    name: 'JointFlex Advanced Complex',
    description:
      'Movilidad sin dolor. Suplemento articular de potencia clínica con Glucosamina, Condroitina, MSM y Ácido Hialurónico. Esencial para razas grandes, perros senior o mascotas con displasia/artritis. Reduce inflamación y regenera cartílago.',
    price: 29.99,
    image:
      'https://images.unsplash.com/photo-1551106652-a5bcf4b29ab6?w=600&h=600&fit=crop',
    category: 'care',
    subcategory: 'supplement',
    petType: 'dog',
    ageGroup: 'senior',
    benefits: [
      'Mejora la movilidad visiblemente',
      'Regeneración de cartílago',
      'Potente antiinflamatorio (MSM)',
      'Lubricación articular',
    ],
    ingredients: [
      'Glucosamina HCl',
      'Condroitina sulfato',
      'MSM (Metilsulfonilmetano)',
      'Ácido hialurónico',
      'Extracto de Cúrcuma',
    ],
    sustainability: 'Envase de vidrio reciclable.',
    weight: '90 comprimidos',
    inStock: true,
    stock: 45,
    rating: 4.9,
    reviewCount: 78,
    certifications: ['Clinical Strength', 'Vet Recommended'],
  },
  {
    id: 'care-salmon-oil',
    name: 'PureSalmon Omega-3 Oil',
    description:
      'El secreto de un pelaje perfecto. Aceite de salmón noruego 100% puro, prensado en frío para conservar sus propiedades. Fuente concentrada de EPA y DHA que combate la piel seca, reduce la caída de pelo y apoya la salud del corazón y cerebro.',
    price: 18.99,
    image:
      'https://images.unsplash.com/photo-1604542031658-579824d1f579?w=600&h=600&fit=crop',
    category: 'care',
    subcategory: 'supplement',
    petType: 'both',
    ageGroup: 'all',
    benefits: [
      'Pelaje brillante y suave',
      'Alivio de picores y alergias',
      'Salud cardiovascular',
      'Refuerzo del sistema inmune',
    ],
    ingredients: [
      'Aceite de salmón noruego (100%)',
      'Vitamina E natural (antioxidante)',
    ],
    sustainability: 'Pesca sostenible certificada.',
    weight: '500ml',
    inStock: true,
    stock: 150,
    rating: 4.9,
    reviewCount: 210,
    certifications: ['Cold Pressed', 'Human Grade', 'Rich in Omega-3'],
  },

  // --- TOYS ---
  {
    id: 'toy-smart-feeder-puzzle',
    name: 'SmartFeeder Puzzle Lvl 2',
    description:
      'Convierte la comida en un juego mental. Rompecabezas interactivo de nivel intermedio que obliga a tu mascota a pensar para obtener su premio. Combate el aburrimiento, reduce la ansiedad destructiva y evita que coman demasiado rápido.',
    price: 24.99,
    image:
      'https://images.unsplash.com/photo-1585837575652-2c9168b04386?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'interactive',
    petType: 'both',
    ageGroup: 'all',
    benefits: [
      'Estimulación mental intensa',
      'Reducción de ansiedad/aburrimiento',
      'Alimentación lenta (Slow Feeder)',
      'Materiales seguros y duraderos',
    ],
    ingredients: [], // Not applicable
    sustainability: 'Plástico reciclado post-consumo.',
    weight: '500g',
    inStock: true,
    stock: 45,
    rating: 4.8,
    reviewCount: 82,
    certifications: ['BPA Free', 'Food Safe Materials'],
  },
  {
    id: 'toy-tough-rope-tug',
    name: 'ToughRope Natural Tug',
    description:
      'Para los juegos más intensos. Cuerda de algodón natural trenzado de alta resistencia. Perfecta para juegos de tirón (tug-of-war) que fortalecen el vínculo y gastan energía física. Las fibras actúan como hilo dental limpiando los dientes mientras juegan.',
    price: 14.99,
    image:
      'https://images.unsplash.com/photo-1546422401-68b415cbf8de?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'chew',
    petType: 'dog',
    ageGroup: 'adult',
    benefits: [
      'Limpieza dental pasiva',
      'Vínculo mediante juego',
      'Alta durabilidad',
      'Material 100% natural seguro',
    ],
    ingredients: [],
    sustainability: 'Algodón orgánico.',
    weight: '300g',
    inStock: true,
    stock: 120,
    rating: 4.9,
    reviewCount: 156,
    certifications: ['Natural Materials', 'Non-Toxic'],
  },
  {
    id: 'toy-eco-plush-bear',
    name: 'EcoPlush Comfort Bear',
    description:
      'Un amigo suave y seguro. Peluche fabricado con telas recicladas y costuras reforzadas de doble capa. Incluye un chirriador interno protegido. Ideal para perros que necesitan un compañero de confort para dormir o llevar consigo.',
    price: 18.99,
    image:
      'https://images.unsplash.com/photo-1535295972055-1c762f4483e5?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'plush',
    petType: 'dog',
    ageGroup: 'all',
    benefits: [
      'Confort emocional y seguridad',
      'Textura suave reconfortante',
      'Sonido estimulante',
      'Lavable a máquina',
    ],
    ingredients: [],
    sustainability: 'Relleno de botellas PET recicladas.',
    weight: '150g',
    inStock: true,
    stock: 80,
    rating: 4.7,
    reviewCount: 94,
    certifications: ['Recycled Materials', 'Reinforced Seams'],
  },
  {
    id: 'toy-laser-chase-pro',
    name: 'LaserChase Pro Automatic',
    description:
      'Diversión autónoma para tu gato. Torre láser automática que proyecta patrones aleatorios impredecibles. Mantiene a tu gato activo y ejercitando su instinto de caza incluso cuando no estás en casa. Temporizador automático de apagado.',
    price: 29.99,
    image:
      'https://images.unsplash.com/photo-1513245543132-31f507417b26?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'interactive',
    petType: 'cat',
    ageGroup: 'all',
    benefits: [
      'Ejercicio físico intenso',
      'Estimulación instinto cazador',
      'Juego autónomo',
      'Seguro para los ojos (Clase 1)',
    ],
    ingredients: [],
    sustainability: 'Batería recargable USB.',
    weight: '200g',
    inStock: true,
    stock: 60,
    rating: 4.6,
    reviewCount: 112,
    certifications: ['Eye Safe Laser', 'USB Rechargeable'],
  },
  {
    id: 'toy-natural-rubber-ball',
    name: 'Natural Bounce Ball',
    description:
      'La pelota clásica, reinventada. Hecha de caucho natural extra resistente con un rebote irregular que hace el juego de "traer" mucho más divertido. Textura diseñada para masajear encías. Flota en el agua para diversión en la playa o piscina.',
    price: 9.99,
    image:
      'https://images.unsplash.com/photo-1598188306155-25e400eb5809?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'training',
    petType: 'dog',
    ageGroup: 'all',
    benefits: [
      'Rebote impredecible divertido',
      'Indestructible (casi)',
      'Flota en agua',
      'Material no tóxico',
    ],
    ingredients: [],
    sustainability: 'Caucho natural biodegradable.',
    weight: '100g',
    inStock: true,
    stock: 200,
    rating: 4.9,
    reviewCount: 320,
    certifications: ['Non-Toxic', 'Natural Rubber'],
  },
  {
    id: 'toy-cat-tunnel-fun',
    name: 'CatTunnel Discovery',
    description:
      'Un parque de atracciones plegable. Túnel espacioso con papel crujiente integrado y mirillas estratégicas. Ofrece un escondite seguro y un espacio de juego emocionante para emboscadas. Se pliega plano para guardar en segundos.',
    price: 22.99,
    image:
      'https://images.unsplash.com/photo-1511044568932-33843d973fe9?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'interactive',
    petType: 'cat',
    ageGroup: 'all',
    benefits: [
      'Refugio y seguridad',
      'Estimulación auditiva (crujido)',
      'Fácil almacenamiento',
      'Espacioso para gatos grandes',
    ],
    ingredients: [],
    sustainability: 'Material duradero de larga vida.',
    weight: '400g',
    inStock: true,
    stock: 55,
    rating: 4.8,
    reviewCount: 88,
    certifications: ['Safety Tested'],
  },
  {
    id: 'toy-dental-cactus',
    name: 'DentalCactus Self-Brush',
    description:
      'El cepillo de dientes que ellos usan solos. Juguete de caucho con forma de cactus y depósito para pasta dental o premios. Las cerdas de goma limpian los dientes mientras el perro mastica instintivamente. Base estable para que lo sujeten con las patas.',
    price: 16.99,
    image:
      'https://images.unsplash.com/photo-1599409636295-e3cf3538f212?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'chew',
    petType: 'dog',
    ageGroup: 'all',
    benefits: [
      'Higiene oral autónoma',
      'Limpia hasta la línea de encías',
      'Resistente a mordidas',
      'Atractivo visual y táctil',
    ],
    ingredients: [],
    sustainability: 'Caucho natural no tóxico.',
    weight: '250g',
    inStock: true,
    stock: 90,
    rating: 4.5,
    reviewCount: 76,
    certifications: ['Dental Aid', 'BPA Free'],
  },
  {
    id: 'toy-feather-wand-deluxe',
    name: 'FeatherWand Deluxe Hunter',
    description:
      'Despierta al tigre interior. Varita premium con plumas naturales, mango ergonómico y cuerda elástica de alta resistencia. Simula el movimiento de un pájaro para activar el instinto depredador y proporcionar ejercicio explosivo a tu gato.',
    price: 12.99,
    image:
      'https://images.unsplash.com/photo-1494256997604-0e1004275f5e?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'interactive',
    petType: 'cat',
    ageGroup: 'all',
    benefits: [
      'Vínculo profundo dueño-gato',
      'Ejercicio aeróbico intenso',
      'Plumas reales atractivas',
      'Varita flexible duradera',
    ],
    ingredients: [],
    sustainability: 'Madera natural y plumas éticas.',
    weight: '50g',
    inStock: true,
    stock: 150,
    rating: 4.9,
    reviewCount: 210,
    certifications: ['Interactive Toy'],
  },
  {
    id: 'toy-snuffle-mat',
    name: 'SnuffleMat Nose Work',
    description:
      'Gimnasio para el olfato. Alfombra densa de tiras de tela donde esconder premios secos. 10 minutos de olfateo equivalen a 1 hora de paseo físico en cuanto a cansancio mental. Reduce el estrés y calma a perros nerviosos.',
    price: 26.99,
    image:
      'https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'interactive',
    petType: 'dog',
    ageGroup: 'all',
    benefits: [
      'Estimulación cognitiva olfativa',
      'Reducción drástica de estrés',
      'Entretenimiento silencioso',
      'Lavable a máquina',
    ],
    ingredients: [],
    sustainability: 'Tela reciclada upcycled.',
    weight: '400g',
    inStock: true,
    stock: 65,
    rating: 4.9,
    reviewCount: 124,
    certifications: ['Enrichment Toy', 'Machine Washable'],
  },
  {
    id: 'toy-flying-disc-pro',
    name: 'AeroFlyer Soft Disc',
    description:
      'Vuelo perfecto, aterrizaje suave. Frisbee diseñado aerodinámicamente para vuelos largos y estables. Fabricado en goma suave pero resistente que no daña los dientes ni encías al atraparlo en el aire. Ideal para el parque o la playa.',
    price: 15.99,
    image:
      'https://images.unsplash.com/photo-1598188306155-25e400eb5809?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'training',
    petType: 'dog',
    ageGroup: 'adult',
    benefits: [
      'Vuelo preciso y estable',
      'Suave con la boca del perro',
      'Flota en el agua',
      'Ejercicio de alta intensidad',
    ],
    ingredients: [],
    sustainability: 'Caucho natural.',
    weight: '180g',
    inStock: true,
    stock: 95,
    rating: 4.7,
    reviewCount: 88,
    certifications: ['Dog Safe Design'],
  },
  {
    id: 'toy-calming-heartbeat-sheep',
    name: 'CalmSheep Heartbeat Plush',
    description:
      'La madre sustituta para cachorros. Peluche terapéutico con un dispositivo que reproduce una vibración y sonido de latido cardíaco real. Reduce drásticamente la ansiedad por separación y el llanto nocturno en cachorros recién llegados.',
    price: 34.99,
    image:
      'https://images.unsplash.com/photo-1535295972055-1c762f4483e5?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'plush',
    petType: 'dog',
    ageGroup: 'puppy',
    benefits: [
      'Elimina ansiedad por separación',
      'Simulación realista de latido',
      'Calor reconfortante (opcional)',
      'Lavable (retirando corazón)',
    ],
    ingredients: [],
    sustainability: 'Materiales seguros.',
    weight: '300g',
    inStock: true,
    stock: 40,
    rating: 4.8,
    reviewCount: 156,
    certifications: ['Puppy Aid', 'Safety Tested'],
  },
  {
    id: 'toy-sisal-scratch-post',
    name: 'SisalTower Scratch Post',
    description:
      'Salva tus muebles con estilo. Poste rascador robusto envuelto en sisal natural de alta calidad. Altura suficiente para permitir que el gato se estire completamente, fundamental para su salud muscular y marcado territorial.',
    price: 32.99,
    image:
      'https://images.unsplash.com/photo-1545249390-6bdfa286032f?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'interactive',
    petType: 'cat',
    ageGroup: 'all',
    benefits: [
      'Protección efectiva de muebles',
      'Cuidado natural de uñas',
      'Estiramiento muscular completo',
      'Base estable antivuelco',
    ],
    ingredients: [],
    sustainability: 'Sisal natural y madera FSC.',
    weight: '2.5kg',
    inStock: true,
    stock: 30,
    rating: 4.6,
    reviewCount: 92,
    certifications: ['FSC Wood', 'Natural Sisal'],
  },
  {
    id: 'toy-electronic-flutter-butterfly',
    name: 'FlutterFly Electric Teaser',
    description:
      'Hipnotizante para cualquier gato. Una mariposa brillante gira y aletea de forma impredecible alrededor de la base. Activa el instinto de caza visual y proporciona ejercicio incluso a gatos sedentarios. Funcionamiento silencioso.',
    price: 24.99,
    image:
      'https://images.unsplash.com/photo-1513245543132-31f507417b26?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'interactive',
    petType: 'cat',
    ageGroup: 'all',
    benefits: [
      'Movimiento realista fascinante',
      'Motor silencioso',
      'Base antideslizante segura',
      'Incluye mariposas de repuesto',
    ],
    ingredients: [],
    sustainability: 'Bajo consumo energético.',
    weight: '350g',
    inStock: true,
    stock: 55,
    rating: 4.5,
    reviewCount: 78,
    certifications: ['CE Certified'],
  },
  {
    id: 'toy-wobble-treat-dispenser',
    name: 'WobbleTreat Bob-A-Lot',
    description:
      'El juguete que nunca se rinde. Dispensador de premios con base pesada que se balancea y tambalea erráticamente pero siempre vuelve a levantarse. Tu perro debe empujarlo con el hocico o patas para liberar la comida. Diversión garantizada.',
    price: 19.99,
    image:
      'https://images.unsplash.com/photo-1585837575652-2c9168b04386?w=600&h=600&fit=crop',
    category: 'toys',
    subcategory: 'interactive',
    petType: 'dog',
    ageGroup: 'all',
    benefits: [
      'Alimentación lenta divertida',
      'Resolución de problemas',
      'Fácil de rellenar y limpiar',
      'Material resistente a golpes',
    ],
    ingredients: [],
    sustainability: 'Plástico ABS seguro.',
    weight: '450g',
    inStock: true,
    stock: 85,
    rating: 4.7,
    reviewCount: 110,
    certifications: ['Food Safe', 'Durable Design'],
  },
]

export const categories = [
  { id: 'dog-food', name: 'Alimentación Perros', petType: 'dog' },
  { id: 'cat-food', name: 'Alimentación Gatos', petType: 'cat' },
  { id: 'snacks', name: 'Snacks y Premios', petType: 'both' },
  { id: 'care', name: 'Cuidado y Salud', petType: 'both' },
  { id: 'toys', name: 'Juguetes y Diversión', petType: 'both' },
]

export const subcategories = {
  'dog-food': [
    { id: 'adult', name: 'Adultos' },
    { id: 'puppy', name: 'Cachorros' },
    { id: 'senior', name: 'Senior' },
    { id: 'special-diet', name: 'Dietas Especiales' },
    { id: 'barf', name: 'BARF / Deshidratada' },
  ],
  'cat-food': [
    { id: 'adult', name: 'Adultos' },
    { id: 'wet', name: 'Comida Húmeda' },
    { id: 'indoor', name: 'Gatos de Interior' },
  ],
  snacks: [
    { id: 'chews', name: 'Masticables' },
    { id: 'freeze-dried', name: 'Liofilizados' },
    { id: 'treats', name: 'Golosinas' },
    { id: 'training', name: 'Entrenamiento' },
    { id: 'natural', name: '100% Natural' },
    { id: 'functional', name: 'Funcionales' },
  ],
  care: [
    { id: 'dental', name: 'Higiene Dental' },
    { id: 'supplement', name: 'Suplementos' },
  ],
  toys: [
    { id: 'interactive', name: 'Interactivos' },
    { id: 'chew', name: 'Mordedores' },
    { id: 'plush', name: 'Peluches' },
    { id: 'training', name: 'Entrenamiento' },
  ],
}

export function getProductById(id: string): Product | undefined {
  return products.find((p) => p.id === id)
}

export function getProductsByCategory(category: string): Product[] {
  return products.filter((p) => p.category === category)
}

export function getProductsByPetType(
  petType: 'dog' | 'cat' | 'both',
): Product[] {
  return products.filter((p) => p.petType === petType || p.petType === 'both')
}

export function getFeaturedProducts(): Product[] {
  return products.filter((p) => p.featured)
}
